import utils from "@/utils"
import Vue from "vue"

const vue = new Vue()

export default {
    sdkLoaded: null,
    code: null,
    initialize() {
        window.addEventListener("message", (event) => {
            if (event.data.message == "googleAuth") {
                const searchString = event.source.window.location.search
                const searchParams = new URLSearchParams(searchString)
                this.code = searchParams.get("code")
                event.source.window.close()
            }
        })
        let promise = utils.createPromise()
        this.sdkLoaded = promise.promise
        if (window["gapi"]) {
            this.configureSDK()
            promise.resolve()
        } else {
            window["googleAsyncInit"] = () => {
                this.configureSDK(() => {
                    promise.resolve()
                })
                delete window["googleAsyncInit"]
            }
        }
    },
    configureSDK(cb) {
        window["gapi"].load("client:auth2", cb)
    },
    async authenticate() {
        try {
            await this.sdkLoaded
            let promise = utils.createPromise()
            window["gapi"].auth2.authorize({
                client_id: "6903882508-ttgnphorn7c3q9e757p13aq1snvcrvku.apps.googleusercontent.com",
                scope: "email profile openid",
                response_type: "code",
                ux_mode: "redirect",
                redirect_uri: `${window.location.origin}/auth/google/callback.html`
            }, (response) => {
                if (response.error && this.code) {
                    promise.resolve({
                        code: this.code
                    })
                } else {
                    promise.resolve(response)
                }
                this.code = null
            })
            return promise.promise
        } catch (e) {
            vue.bugsnag.notify(
                "Failed to Login with Google",
                (event) => {
                    event.addMetadata("reason", {
                        error: e
                    })
                }
            )
        }
    }
}